import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  ProgramDropdown,
  TimesheetTaskDropdown,
  UserDropdown,
} from "CommonDropdowns";
import { map, isEmpty } from "lodash";
import moment from "moment";
import { hideWeeklyTimesheetValidationError } from "actions";

const getMonthOptions = () => {
  const options = [];
  const start = moment().add(1, "month").startOf("month");

  for (let i = 0; i < 24; i++) {
    const m = start.clone().subtract(i, "months");
    options.push(m.format("YYYY-MM"));
  }

  return options;
};

const Filter = ({
  onFilter,
  extraFiltersState,
  setExtraFiltersState,
  currentMonth,
  setCurrentMonth,
}) => {
  const dispatch = useDispatch();
  const [programValue, setProgramValue] = useState([]);
  const [taskValue, setTaskValue] = useState([]);
  const [userValue, setUserValue] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  useEffect(() => {
    const months = getMonthOptions();
    setMonthOptions(months);

    const currentMonthStr = moment().startOf('month').format("YYYY-MM");

    setCurrentMonth(currentMonthStr);

    // update filters
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, month_year: currentMonthStr },
    }));
  }, []);

  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    setProgramValue([]);
    setTaskValue([]);
    setUserValue([]);
  };

  const handleSearch = () => {
    onFilter();
  };

  const handleProgramDelete = (row) => {
    setProgramValue([]);
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, program_id: [] },
    }));
  };

  // const handleProgramChange = (selected) => {
  //   setProgramValue(selected);
  //   setExtraFiltersState((prev) => ({
  //     ...prev,
  //     values: {
  //       ...prev.values,
  //       program_id: !isEmpty(selected) ? selected.value : '',
  //       task_ids: !isEmpty(selected) ? prev.values.task_ids : [],
  //       user_ids: !isEmpty(selected) ? prev.values.user_ids : [],
  //     },
  //   }));
  // };


  const handleProgramChange = (selected) => { 
    setProgramValue(selected);
    // Extract program IDs from selected array (for multi-select)
    const program_ids = !isEmpty(selected) ? selected.map(item => item.value) : [];
    setExtraFiltersState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        program_id: program_ids,
        user_ids: [], // Reset user_ids when program changes (users must be from selected program)
        task_ids: [], // Reset task_ids when program changes
      },
    }));
    // Reset user and task values when program changes
    setUserValue([]);
    setTaskValue([]);
    dispatch(hideWeeklyTimesheetValidationError('program_id'));
  }

  // const handleTaskChange = (selected) => {
  //   setTaskValue(selected);
  //   setExtraFiltersState((prev) => ({
  //     ...prev,
  //     values: { ...prev.values, task_ids: !isEmpty(selected) ? selected.map(item => item.value) : [] },
  //   }));
  // };


  const handleTaskChange = (selected) => {
    setTaskValue(selected);
    setExtraFiltersState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        task_ids: selected ? selected.map(item => item.value) : [],
      },
    }));
    dispatch(hideWeeklyTimesheetValidationError('task_ids'));
  }



  const handleUserChange = (selected) => {
    setUserValue(selected);
    const user_ids = map(selected, "value");
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, user_ids: user_ids, task_ids: [] },
    }));
    setTaskValue([]);
  };

  const handleChange = (event) => {
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, [event.target.name]: event.target.value },
    }));
  };

  return (
    <section className="filters-flex">
      <Form>
        <Row
          className="align-items-end"
          style={{ gap: "16px", flexWrap: "nowrap" }}
        >
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Month</Form.Label>
              <Form.Select
                className="input-field"
                name="month_year"
                onChange={handleChange}
                value={extraFiltersState.values.month_year || ""}
              >
                <option value="">Select Month</option>
                {monthOptions.map((month_year) => (
                  <option key={month_year} value={month_year}>
                    {moment(month_year, "YYYY-MM").format("MMMM YYYY")}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col>
            <ProgramDropdown
              programValue={programValue}
              programOnChange={handleProgramChange}
              setProgramValue={setProgramValue}
              isMulti={true}
              selectedId={extraFiltersState.values.program_id}
              loadManagerPrograms={true}
            />
          </Col>

              <Col>
                <UserDropdown
                  key={extraFiltersState.values.program_id && extraFiltersState.values.program_id.length > 0 
                    ? `user-dropdown-${Array.isArray(extraFiltersState.values.program_id) 
                        ? extraFiltersState.values.program_id[0] 
                        : extraFiltersState.values.program_id}` 
                    : 'user-dropdown-no-program'}
                  userValue={userValue}
                  userOnChange={handleUserChange}
                  setUserValue={setUserValue}
                  isMulti={true}
                  selectedId={extraFiltersState.values.user_ids}
                  loadUnbindedOnly={false}
                  programId={extraFiltersState.values.program_id && extraFiltersState.values.program_id.length > 0 
                    ? (Array.isArray(extraFiltersState.values.program_id) && extraFiltersState.values.program_id.length === 1
                        ? extraFiltersState.values.program_id[0]  // Pass single program ID if only one selected
                        : extraFiltersState.values.program_id[0])  // Pass first program ID if multiple selected
                    : undefined}
                  loadManagerProgramUsers={true}
                />
              </Col>
              
          {extraFiltersState.values.program_id && 
            extraFiltersState.values.program_id.length > 0 &&
            extraFiltersState.values.user_ids && 
            extraFiltersState.values.user_ids.length > 0 && (
              <Col>
                <TimesheetTaskDropdown
                  taskValue={taskValue}
                  taskOnChange={handleTaskChange}
                  setTaskValue={setTaskValue}
                  isMulti={true}
                  name="task_ids"
                  programId={Array.isArray(extraFiltersState.values.program_id) 
                    ? extraFiltersState.values.program_id[0]  // Use first program if multiple selected
                    : extraFiltersState.values.program_id}
                  user_ids={extraFiltersState.values.user_ids}
                  selectedId={extraFiltersState.values.task_ids}
                  showSelectAllOption={false}
                  loadUnbinded={false}
                />
              </Col>
            )}
          <Col xs="auto">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn mb-3"
            >
              <img
                src="/assets/images/search-white.svg"
                alt=""
                className="me-2"
              />{" "}
              Search
            </button>
          </Col>
          {/* <Col>
            <button
              type="button"
              className="btn btn-link mb-2"
              onClick={handleClear}
            >
              Clear
            </button>
          </Col> */}
        </Row>
      </Form>
    </section>
  );
};

export default Filter;
